import { render, staticRenderFns } from "./personCompany.component.vue?vue&type=template&id=70b1f535&scoped=true&"
import script from "./personCompany.component.vue?vue&type=script&lang=js&"
export * from "./personCompany.component.vue?vue&type=script&lang=js&"
import style0 from "./personCompany.component.vue?vue&type=style&index=0&id=70b1f535&scoped=true&lang=scss&"
import style1 from "./personCompany.component.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b1f535",
  null
  
)

export default component.exports